import { render, staticRenderFns } from "./organize.vue?vue&type=template&id=5fefa7e8&scoped=true&"
import script from "./organize.vue?vue&type=script&lang=js&"
export * from "./organize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fefa7e8",
  null
  
)

export default component.exports